"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TexasHoldemOptions = void 0;
/** TexasHoldemOptions.tsx
 *
 * Game Options for TexasHold'em.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.TexasHoldemOptions = {
    versions: [
        {
            title: "No-Limit",
            description: "No-Limit w/ Blinds",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            default: true,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.NO_LIMIT,
        },
        {
            title: "Spread-Limit",
            description: "Spread-Limit w/ Antes",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [defaultOptions_1.winnerHighOnlyDefault],
    options: [defaultOptions_1.optionNoneDefault],
    wildcards: [
        defaultOptions_1.wildcardNoneDefault,
        defaultOptions_1.wildcardLowHole,
        defaultOptions_1.wildcardDeuces,
        defaultOptions_1.wildcardOneEyedJacks,
    ],
};
//# sourceMappingURL=TexasHoldemOptions.js.map